import React, { useState } from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import { useDeviceDetection } from '../hooks/useDeviceDetection';
import PersistentHeader from '../components/PersistentHeader';
import '../pages/Dashboard/Dashboard.css';

/**
 * ResponsiveLayout - Clean, simple layout that works on both mobile and desktop
 * Uses a single layout structure that adapts with CSS media queries
 */
const ResponsiveLayout: React.FC = () => {
  const { isMobile, isTablet } = useDeviceDetection();
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  
  // Mobile/tablet should always have collapsed sidebar with no toggle
  const isMobileOrTablet = isMobile || isTablet;
  
  // Hide navigation AND header on game pages for immersive experience
  const isGamePage = location.pathname.includes('/game') || 
                     location.pathname.includes('/lobby');

  if (isGamePage) {
    // Game pages get full screen without navigation or header
    return (
      <div className="game-layout">
        <Outlet />
      </div>
    );
  }

  return (
    <>
      {/* Persistent Header - Shows on all non-game pages */}
      <PersistentHeader />
      
      <div 
        className="dashboard-container" 
        style={{ 
          paddingTop: window.innerWidth >= 1024 ? '70px' : window.innerWidth >= 768 ? '60px' : '60px'
        }}
      >
        {/* Sidebar Navigation */}
        <div className={`sidebar ${(sidebarCollapsed || isMobileOrTablet) ? 'collapsed' : ''}`}>
        {/* Sidebar Toggle Button - Only show on desktop */}
        {!isMobileOrTablet && (
          <button 
            className="sidebar-toggle-btn"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            title={sidebarCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
          >
            {sidebarCollapsed ? '→' : '←'}
          </button>
        )}

        {/* Sidebar Title */}
        <div className="sidebar-title">
          <span>Navigation</span>
        </div>

        {/* Navigation Items */}
        <div className="nav-items">
          <Link 
            to="/dashboard"
            className={`nav-item ${location.pathname === '/dashboard' ? 'active' : ''}`}
          >
            <span className="nav-icon">📊</span>
            <span className="nav-text">Dashboard</span>
          </Link>
          
          <Link 
            to="/rooms"
            className={`nav-item ${location.pathname.startsWith('/rooms') ? 'active' : ''}`}
          >
            <span className="nav-icon">🎯</span>
            <span className="nav-text">Game Rooms</span>
          </Link>
          
          <Link 
            to="/profile"
            className={`nav-item ${location.pathname.startsWith('/profile') ? 'active' : ''}`}
          >
            <span className="nav-icon">👤</span>
            <span className="nav-text">Profile & Stats</span>
          </Link>
          
          <Link
            to="/settings"
            className={`nav-item ${location.pathname.startsWith('/settings') ? 'active' : ''}`}
          >
            <span className="nav-icon">⚙️</span>
            <span className="nav-text">Settings</span>
          </Link>
        </div>

        {/* User Section removed - now in PersistentHeader */}
      </div>

      {/* Main Content Area */}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
    </>
  );
};

export default ResponsiveLayout;